// Chain ID → explorer + readable name + Uniswap V3 addresses (WETH, NFPManager).
// Auto-liquidity works only on chains with non-null lp config.
export const NETWORKS = {
  1: {
    name: 'Ethereum Mainnet', explorer: 'https://etherscan.io', short: 'ETH', preferred: false,
    weth: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    nfpm: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  },
  11155111: {
    name: 'Sepolia', explorer: 'https://sepolia.etherscan.io', short: 'SEP', preferred: false,
    weth: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
    nfpm: '0x1238536071E1c677A632429e3655c799b22cDA52',
  },
  8453: {
    name: 'Base', explorer: 'https://basescan.org', short: 'BASE', preferred: true,
    weth: '0x4200000000000000000000000000000000000006',
    nfpm: '0x03a520b32C04BF3bEEf7BEb72E919cf822Ed34f1',
  },
  84532: {
    name: 'Base Sepolia', explorer: 'https://sepolia.basescan.org', short: 'BASE-SEP', preferred: true,
    weth: '0x4200000000000000000000000000000000000006',
    nfpm: '0x27F971cb582BF9E50F397e4d29a5C7A34f11faA2',
  },
  137: { name: 'Polygon', explorer: 'https://polygonscan.com', short: 'POL', preferred: false, weth: null, nfpm: null },
  10: { name: 'Optimism', explorer: 'https://optimistic.etherscan.io', short: 'OP', preferred: false, weth: null, nfpm: null },
  42161: { name: 'Arbitrum', explorer: 'https://arbiscan.io', short: 'ARB', preferred: false, weth: null, nfpm: null },
};

export const DEFAULT_CHAIN_ID = 84532; // Base Sepolia — cheap testing

// wallet_addEthereumChain params for chains users can launch on.
export const CHAIN_PARAMS = {
  1: {
    chainId: '0x1', chainName: 'Ethereum Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: ['https://ethereum-rpc.publicnode.com'], blockExplorerUrls: ['https://etherscan.io'],
  },
  11155111: {
    chainId: '0xaa36a7', chainName: 'Sepolia',
    nativeCurrency: { name: 'Sepolia ETH', symbol: 'ETH', decimals: 18 },
    rpcUrls: ['https://ethereum-sepolia-rpc.publicnode.com'], blockExplorerUrls: ['https://sepolia.etherscan.io'],
  },
  8453: {
    chainId: '0x2105', chainName: 'Base',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: ['https://mainnet.base.org'], blockExplorerUrls: ['https://basescan.org'],
  },
  84532: {
    chainId: '0x14a34', chainName: 'Base Sepolia',
    nativeCurrency: { name: 'Sepolia ETH', symbol: 'ETH', decimals: 18 },
    rpcUrls: ['https://sepolia.base.org'], blockExplorerUrls: ['https://sepolia.basescan.org'],
  },
};

// Launch-capable chains shown in the Dashboard network selector.
export const LAUNCH_CHAINS = [
  { id: 8453, label: 'Base', note: 'Recommended · cheap gas', warn: false },
  { id: 84532, label: 'Base Sepolia', note: 'Testnet · free', warn: false },
  { id: 1, label: 'Ethereum', note: 'Expensive · ~$50+ gas', warn: true },
  { id: 11155111, label: 'Sepolia', note: 'Testnet · free', warn: false },
];

export const networkOf = (chainId) =>
  NETWORKS[chainId] || { name: `Chain ${chainId}`, explorer: '', short: `#${chainId}`, weth: null, nfpm: null };

export const hasLpSupport = (chainId) => {
  const n = networkOf(chainId);
  return !!(n.weth && n.nfpm);
};

export const txUrl = (chainId, hash) => {
  const n = networkOf(chainId);
  return n.explorer ? `${n.explorer}/tx/${hash}` : '';
};

export const addressUrl = (chainId, addr) => {
  const n = networkOf(chainId);
  return n.explorer ? `${n.explorer}/address/${addr}` : '';
};

export const tokenUrl = (chainId, addr) => {
  const n = networkOf(chainId);
  return n.explorer ? `${n.explorer}/token/${addr}` : '';
};

// Uniswap trade URLs — chain slug used by app.uniswap.org
const UNI_CHAIN_SLUG = {
  1: 'mainnet',
  11155111: 'sepolia',
  8453: 'base',
  84532: 'base_sepolia',
};
export const uniswapUrl = (chainId, addr) => {
  const slug = UNI_CHAIN_SLUG[chainId];
  if (!slug) return '';
  return `https://app.uniswap.org/swap?chain=${slug}&outputCurrency=${addr}`;
};

// Basescan/Etherscan "Verify & Publish" URL (opens contract page → user clicks verify).
// Full API verification would require a per-user Basescan API key; skipped for MVP.
export const verifyUrl = (chainId, addr) => {
  const n = networkOf(chainId);
  if (!n.explorer) return '';
  return `${n.explorer}/address/${addr}#code`;
};
